<small *ngIf="control.errors" [style.display]="hidden ? 'none' : 'initial'" class="p-text-red">
  {{
    control.errors | calendarErrorMapping : errorsMap: showRequired | translate:
    {
      fieldName:
        fieldName | translate
    }
  }}
</small>
